(function ($) {
    if (!$('body').hasClass('page-template-template-calendar')) {
        $('table').each(function (index) {
            $(this).wrap('<div class="table-container">');
            new SimpleBar($(this).parent()[0]);
        });
    }
})(jQuery);